import { errorView } from "./ErrorHandler";

export enum AccordionTypes {
  RECIPE = 1,
  CIP_SIP = 2,
  CHEMICALS = 3,
  WASTE_MANAGEMENT = 4,
  HEAT_SOURCE = 5
}
export enum AccordionNames {
  CIP_SIP = "CIP/SIP",
  CHEMICALS = "chemicals",
  WASTE_MANAGEMENT = "waste/side streams",
  RECIPE = "recipe",
}

const AccordionName = {
  [AccordionTypes.RECIPE]: "recipe",
  [AccordionTypes.CIP_SIP]: "CIP/SIP",
  [AccordionTypes.CHEMICALS]: "chemicals",
  [AccordionTypes.WASTE_MANAGEMENT]: "waste/side streams",
  [AccordionTypes.HEAT_SOURCE]: "heat source"
} as const;

export const validateAccordionOpen = (
  processId: string | undefined,
  activeAccordion: AccordionTypes | null,
  requestAccordion: AccordionTypes
): boolean => {
  if (!processId) {
    errorView(
      `Please save the process details before adding ${AccordionName[requestAccordion]} information.`
    );
    return false;
  }

  if (activeAccordion && AccordionTypes[activeAccordion] !== AccordionTypes[requestAccordion]) {
    errorView(
      `Please close or save the ${AccordionName[activeAccordion]} details before opening ${AccordionName[requestAccordion]}.`
    );
    return false;
  }

  return true;
};

export const validateAccordionSubmit = (activeAccordion: AccordionTypes | null): boolean => {
  if (activeAccordion) {
    errorView(
      `Please close or save the ${AccordionName[activeAccordion]} details before updating the process.`
    );
    return false;
  }
  return true;
};
